import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPartners = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Frame 3",
		children: [
			/* @__PURE__ */ _jsx("circle", {
				id: "Ellipse 20",
				cx: 5.83324,
				cy: 12.0833,
				r: 2.08333,
				stroke: "",
				strokeWidth: 1.4,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("circle", {
				id: "Ellipse 23",
				cx: 14.1666,
				cy: 12.0833,
				r: 2.08333,
				stroke: "",
				strokeWidth: 1.4,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("circle", {
				id: "Ellipse 24",
				cx: 9.9999,
				cy: 3.74996,
				r: 2.08333,
				stroke: "",
				strokeWidth: 1.4,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Ellipse 21",
				d: "M9.9999 18.3333C9.9999 16.0321 8.13442 14.1666 5.83323 14.1666C3.53205 14.1666 1.66656 16.0321 1.66656 18.3333",
				stroke: "",
				strokeWidth: 1.4,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Ellipse 22",
				d: "M18.3332 18.3333C18.3332 16.0321 16.4678 14.1666 14.1666 14.1666C11.8654 14.1666 9.99991 16.0321 9.99991 18.3333",
				stroke: "",
				strokeWidth: 1.4,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Ellipse 25",
				d: "M14.1666 10C14.1666 7.69885 12.3011 5.83337 9.99992 5.83337C7.69873 5.83337 5.83325 7.69885 5.83325 10",
				stroke: "",
				strokeWidth: 1.4,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	})
});
export default SvgPartners;
